import { useAuthStorePersist } from "@/store/authStorePersist";

const useAuth = () => {
  const user = useAuthStorePersist((state) => state.user);
  return user;
};

export default useAuth;
